import * as _ from 'lodash'
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    loading: false,
    errors: [],
    purchase: JSON.parse(sessionStorage.getItem('purchase') || '{}'),
    desiredAmountInCents: sessionStorage.getItem('desiredAmountInCents') || 0,
    numberOfVouchers: sessionStorage.getItem('numberOfVouchers') || 1,
    redeemableVouchers: JSON.parse(sessionStorage.getItem('redeemableVouchers') || '[]'),
    voucherDenominationCurrency: sessionStorage.getItem('voucherDenominationCurrency') || '',
    marketingConsent: sessionStorage.getItem('marketingConsent') === 'true',
  },
  getters: {
    purchase: (state) => state.purchase,
    amountToPayInCents: (state) => state.purchase.amountToPayInCents || state.desiredAmountInCents,
    numberOfVouchers: (state) => state.purchase.numberOfVouchers || state.numberOfVouchers,
    voucherDenominationCurrency: (state) => state.purchase.voucherDenominationCurrency || state.voucherDenominationCurrency,
    loading: (state) => state.loading,
    errors: (state) => state.errors,
    redeemableVouchers: (state) => state.redeemableVouchers,
    marketingConsent: (state) => state.marketingConsent,
  },
  actions: {
    async initiatePurchase({ commit, state }, { locale }) {
      if (!state.desiredAmountInCents) {
        return
      }

      // commit('RESET_ERRORS');
      commit('SET_LOADING_STATE', { loading: true })

      try {
        const payload = {
          voucherDenominationCents: state.desiredAmountInCents,
          numberOfVouchers: state.numberOfVouchers,
          currency: state.voucherDenominationCurrency,
          locale,
        }

        const { data } = await axios.post('/voucher_sales', payload)

        commit('AMEND_PURCHASE', data)
      } catch ({ response }) {
        commit('SET_ERRORS', { response })
      } finally {
        commit('SET_LOADING_STATE', { loading: false })
      }
    },
    async amendPurchase({ commit }, { data }) {
      commit('AMEND_PURCHASE', data)
    },
    async secure3dRequired({ commit }, { purchaseId }) {
      commit('RESET_ERRORS')
      commit('SET_LOADING_STATE', { loading: true })

      try {
        const response = await axios.get(`/voucher_sales/${purchaseId}/3d_secure_required`)
        commit('AMEND_PURCHASE', { secure3dRequired: response.data.redirect })
      } catch ({ response }) {
        commit('SET_ERRORS', { response })
      } finally {
        commit('SET_LOADING_STATE', { loading: false })
      }
    },
    async checkout({ commit, state }, payload) {
      commit('RESET_ERRORS')
      commit('SET_LOADING_STATE', { loading: true })

      try {
        const checkoutPayload = {
          ...payload,
          marketingConsent: state.marketingConsent,
        }
        const { data } = await axios.put(`/voucher_sales/${payload.purchaseId}/checkout`, checkoutPayload)
        commit('SET_REDEEMABLE_VOUCHERS', data.redeemableVouchers)
        // commit('RESET_PURCHASE')
        commit('RESET_DESIRED_AMOUNT_IN_CENTS')
        commit('RESET_NUMBER_OF_VOUCHERS')
        commit('RESET_MARKETING_CONSENT')
      } catch ({ response }) {
        commit('SET_ERRORS', { response })
      } finally {
        commit('SET_LOADING_STATE', { loading: false })
      }
    },
    setActiveItem({ commit }, item) {
      commit('SET_ACTIVE_ITEM', item)
    },
    setLoadingState({ commit }, { loading }) {
      commit('SET_LOADING_STATE', { loading })
    },
    setErrors({ commit }, { errors }) {
      commit('SET_ERRORS', { response: { status: 422, data: { errors } } })
    },
    resetErrors({ commit }) {
      commit('RESET_ERRORS')
    },
    setDesiredAmountInCents({ commit }, desiredAmount) {
      commit('SET_DESIRED_AMOUNT_IN_CENTS', desiredAmount)
    },
    setNumberOfVouchers({ commit }, numberOfVouchers) {
      commit('SET_NUMBER_OF_VOUCHERS', numberOfVouchers)
    },
    setVoucherDenominationCurrency({ commit }, voucherDenominationCurrency) {
      commit('SET_VOUCHER_DENOMINATION_CURRENCY', voucherDenominationCurrency)
    },
    setMarketingConsent({ commit }, marketingConsent) {
      commit('SET_MARKETING_CONSENT', marketingConsent)
    },
    loadStateFromSession({ commit }) {
      const purchase = JSON.parse(sessionStorage.getItem('purchase'))
      if (purchase) { commit('SET_PURCHASE', purchase) }
    },
  },
  mutations: {
    SET_PURCHASE(state, purchase) {
      state.purchase = purchase
      sessionStorage.setItem('purchase', JSON.stringify(state.purchase))
    },
    RESET_PURCHASE(state) {
      state.purchase = {}
      sessionStorage.removeItem('purchase')
    },
    AMEND_PURCHASE(state, data) {
      state.purchase = {
        ...state.purchase,
        ...data,
      }

      sessionStorage.setItem('purchase', JSON.stringify(state.purchase))
    },
    SET_REDEEMABLE_VOUCHERS(state, redeemableVouchers) {
      state.redeemableVouchers = redeemableVouchers
      sessionStorage.setItem('redeemableVouchers', JSON.stringify(state.redeemableVouchers))
    },
    SET_ERRORS(state, { response }) {
      state.errors = []

      if (response.data && [422, 404, 400].includes(response.status)) {
        if (response.data.errors && _.isArray(response.data.errors)) {
          state.errors = response.data.errors
        } else {
          state.errors = ['general']
        }
      } else {
        state.errors = ['general']
      }
    },
    RESET_ERRORS(state) {
      state.errors = []
    },
    SET_LOADING_STATE(state, { loading }) {
      state.loading = loading
    },
    SET_ITEMS(state, items) {
      state.items = items
    },
    SET_POPULATED(state) {
      state.populated = true
    },
    SET_DESIRED_AMOUNT_IN_CENTS(state, amount) {
      state.desiredAmountInCents = amount
      sessionStorage.setItem('desiredAmountInCents', amount)
    },
    RESET_DESIRED_AMOUNT_IN_CENTS(state) {
      state.desiredAmountInCents = 0
      sessionStorage.removeItem('desiredAmountInCents')
    },
    SET_NUMBER_OF_VOUCHERS(state, numberOfVouchers) {
      state.numberOfVouchers = numberOfVouchers
      sessionStorage.setItem('numberOfVouchers', numberOfVouchers)
    },
    RESET_NUMBER_OF_VOUCHERS(state) {
      state.numberOfVouchers = 1
      sessionStorage.removeItem('numberOfVouchers')
    },
    SET_VOUCHER_DENOMINATION_CURRENCY(state, currency) {
      state.voucherDenominationCurrency = currency
      sessionStorage.setItem('voucherDenominationCurrency', currency)
    },
    SET_MARKETING_CONSENT(state, marketingConsent) {
      state.marketingConsent = marketingConsent
      if (marketingConsent) {
        sessionStorage.setItem('marketingConsent', 'true')
      } else {
        sessionStorage.removeItem('marketingConsent')
      }
    },
    RESET_MARKETING_CONSENT(state) {
      state.marketingConsent = false
      sessionStorage.removeItem('marketingConsent')
    },
  },
}
